import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { h3 } from '@helpers/typography';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  background-color: ${brand.primary.blueGrey};

  @media ${from(Device.TabletLarge)} {
    ${SectionWrapperStyles.Inner} {
      ${baseGrid};
    }
  }
`;
const TitleWrapper = styled.div `
  @media ${from(Device.TabletLarge)} {
    display: flex;
    align-items: center;
    grid-column: 1 / span 6;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 1 / span 5;
  }
`;
const Title = styled.h2 `
  ${transition('opacity, transform', 0.5)};
  ${h3};

  margin-bottom: 0;

  ${Container}[data-animate='false'] & {
    transform: translateY(50%);
    opacity: 0;
  }

  @media ${from(Device.TabletLarge)} {
    margin-bottom: ${fluid(64, 128)};
  }
`;
const CardWrapper = styled.div `
  padding-top: 32px;

  @media ${from(Device.TabletLarge)} {
    grid-column: 8 / span 17;
    padding: 0;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 7 / span 18;
  }
`;
const SingleTestimonialStyles = {
    CardWrapper,
    Container,
    Title,
    TitleWrapper,
};
export default SingleTestimonialStyles;
